var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"close","d":"M9.134,8,15.756,1.36a.768.768,0,0,0,0-1.12.768.768,0,0,0-1.12,0L8,6.863,1.36.241a.768.768,0,0,0-1.12,0,.768.768,0,0,0,0,1.12L6.863,8,.241,14.636a.768.768,0,0,0,0,1.12.768.768,0,0,0,1.12,0L8,9.134l6.638,6.622a.792.792,0,1,0,1.12-1.12Z","transform":"translate(0.002 0.002)","fill":"#666"}));
}

IconClose.defaultProps = {"id":"icon_close","width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = IconClose;

IconClose.default = IconClose;
